import React, { useState, useEffect } from 'react';
import { Typography, Button, message, Alert, Space } from 'antd';
import { CheckCircleOutlined, MailOutlined } from '@ant-design/icons';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import apiService from '@/services/api.service';
import { logger } from '@/utils/logger';
import { VerifyEmailContainer, StyledCard } from './styles/VerifyEmail.styles';

const { Title, Text } = Typography;

const VerifyEmail: React.FC = () => {
    const [loading, setLoading] = useState(true);
    const [verified, setVerified] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const token = searchParams.get('token');

    useEffect(() => {
        const verifyToken = async () => {
            if (!token) {
                setError('Токен не указан');
                setLoading(false);
                return;
            }

            try {
                const response: any = await apiService.get(`/auth/verify-email?token=${token}`);
                if (response.data?.status === 'success') {
                    setVerified(true);
                    message.success('Email успешно подтвержден!');
                    // Перенаправляем на страницу входа через 3 секунды
                    setTimeout(() => {
                        navigate('/login');
                    }, 3000);
                }
            } catch (error: any) {
                logger.error('Error verifying email:', error);
                setError(error.response?.data?.message || 'Не удалось подтвердить email');
            } finally {
                setLoading(false);
            }
        };

        verifyToken();
    }, [token, navigate]);


    if (loading) {
        return (
            <VerifyEmailContainer>
                <StyledCard>
                    <div style={{ textAlign: 'center' }}>
                        <Title level={3}>Подтверждение email...</Title>
                    </div>
                </StyledCard>
            </VerifyEmailContainer>
        );
    }

    if (verified) {
        return (
            <VerifyEmailContainer>
                <StyledCard>
                    <div style={{ textAlign: 'center' }}>
                        <CheckCircleOutlined style={{ fontSize: 48, color: '#52c41a', marginBottom: 16 }} />
                        <Title level={3}>Email подтвержден!</Title>
                        <Text type="secondary" style={{ display: 'block', marginBottom: 24 }}>
                            Ваш email успешно подтвержден. Вы будете перенаправлены на страницу входа через несколько секунд...
                        </Text>
                        <Link to="/login">
                            <Button type="primary">Перейти к входу</Button>
                        </Link>
                    </div>
                </StyledCard>
            </VerifyEmailContainer>
        );
    }

    return (
        <VerifyEmailContainer>
            <StyledCard>
                <div style={{ textAlign: 'center' }}>
                    <MailOutlined style={{ fontSize: 48, color: '#ff4d4f', marginBottom: 16 }} />
                    <Title level={3}>Ошибка подтверждения</Title>
                    <Alert
                        message={error || 'Не удалось подтвердить email'}
                        type="error"
                        showIcon
                        style={{ marginBottom: 24 }}
                    />
                    <Space direction="vertical" style={{ width: '100%' }}>
                        <Text type="secondary">
                            Ссылка для подтверждения недействительна или истекла.
                        </Text>
                        <Button type="primary" onClick={() => navigate('/login')}>
                            Перейти к входу
                        </Button>
                    </Space>
                </div>
            </StyledCard>
        </VerifyEmailContainer>
    );
};

export default VerifyEmail;

